<email-layout>
  <ng-container logo>
    <email-referrals-logo [lang]="data.language" />
  </ng-container>

  <ng-container header>
    <email-message-header
      [header]="data.title"
      [subheader]="data.p1"
      [imageUrl]="data.avatar_url"
      [imageAlt]="data.title"
    />
  </ng-container>

  <ng-container body>
    <ng-container *mailgunIf="data.message_html">
      <email-infobox [contents]="data.message_html" />
      <email-margin [height]="28" />
    </ng-container>
    <email-text [contents]="data.p2 | mailgunMarkAsHtml" color="light" />
    <email-margin [height]="36" />
    <email-button [href]="data.button_link" [label]="data.button_text" theme="primary" />
  </ng-container>

  <ng-container footer>
    <email-text
      [contents]="data.footer.text"
      color="light"
      presetName="inline"
      size="small"
    />&nbsp;
    <email-link
      [label]="data.footer.label"
      [href]="data.footer.href"
      [target]="data.footer.target"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
